{
  "_fallback": "Ein Fehler ist aufgetreten",

  "backup_archive_missing": "Backup-Datei nicht gefunden",
  "backup_manifest_missing": "Backup hat kein Manifest",
  "backup_manifest_unreadable": "Manifest nicht lesbar",
  "backup_manifest_invalid": "Manifest-Format ungültig",
  "backup_version_unsupported": "Backup-Version {{version}} wird nicht unterstützt",
  "backup_kind_mismatch": "Falscher Backup-Typ: {{kind}}",
  "backup_tar_corrupt": "Tar-Archiv beschädigt: {{error}}",
  "backup_db_unreadable": "Datenbank im Backup nicht lesbar",
  "backup_db_corrupt": "Datenbank im Backup beschädigt: {{detail}}",
  "backup_filename_missing": "Datei-Name fehlt",
  "backup_create_failed": "Backup konnte nicht erstellt werden: {{error}}",
  "backup_restore_failed": "Restore fehlgeschlagen: {{error}}",

  "invalid_credentials": "Ungültige Zugangsdaten",
  "too_many_login_attempts": "Zu viele fehlgeschlagene Login-Versuche, bitte später erneut versuchen.",
  "not_authenticated": "Nicht authentifiziert",
  "token_expired": "Token abgelaufen",
  "invalid_token": "Ungültiger Token",
  "admin_only": "Nur für Admins",

  "agent_not_found": "Agent nicht gefunden",
  "agent_no_access": "Kein Zugriff auf diesen Agent",
  "soul_active": "Soul ist aktiv — der System-Prompt wird nicht verwendet. Bearbeite die Soul im Reiter „Soul“ oder leere dort alle Felder.",

  "session_not_found": "Session nicht gefunden",
  "session_no_access": "Kein Zugriff auf diese Session",
  "upload_file_too_large": "{{filename}} ist zu groß. Maximal {{max_mib}} MiB pro Datei.",
  "upload_total_too_large": "Die Anhänge sind zusammen zu groß. Maximal {{max_mib}} MiB pro Nachricht.",
  "upload_too_many_files": "Es sind maximal {{max_files}} Dateien pro Nachricht erlaubt.",
  "upload_size_unknown": "Die Dateigröße konnte nicht bestimmt werden.",

  "project_not_found": "Projekt nicht gefunden",
  "project_no_access": "Kein Zugriff auf dieses Projekt",
  "project_agent_not_found": "Project-Agent nicht gefunden",

  "mcp_server_not_found": "MCP-Server nicht gefunden",
  "mcp_template_not_found": "Template '{{template_id}}' unbekannt",
  "mcp_connection_failed": "Verbindung fehlgeschlagen: {{message}}",
  "mcp_tool_listing_failed": "Tool-Listing fehlgeschlagen: {{message}}",

  "llm_test_failed": "LLM-Test fehlgeschlagen: {{message}}",

  "update_script_missing": "Update-Script nicht gefunden — nur in Production-Setup verfügbar",
  "update_trigger_failed": "Update-Trigger fehlgeschlagen: {{message}}",
  "restart_trigger_failed": "Restart-Trigger fehlgeschlagen: {{message}}",

  "plugin_hub_unreachable": "Plugin-Hub nicht erreichbar: {{message}}",
  "plugin_install_failed": "Plugin-Installation fehlgeschlagen: {{message}}",
  "plugin_uninstall_failed": "Plugin-Entfernung fehlgeschlagen: {{message}}",
  "plugin_update_failed": "Plugin-Update fehlgeschlagen: {{message}}",

  "username_exists": "Benutzername existiert bereits",
  "user_not_found": "Benutzer nicht gefunden",
  "last_admin_cannot_demote": "Der letzte Admin kann nicht degradiert werden",
  "invalid_role": "Ungültige Rolle: {{role}}",
  "agentlink_not_configured": "AgentLink ist nicht konfiguriert (HH_AGENTLINK_URL fehlt)",
  "agentlink_listener_never_started": "Listener wurde noch nie gestartet — Service neu starten nötig",
  "agentlink_failed": "AgentLink-Reconnect fehlgeschlagen: {{detail}}",
  "message_not_found": "Nachricht nicht gefunden",
  "message_not_editable": "Nur eigene User-Nachrichten können editiert werden",
  "vm_must_be_stopped": "VM muss gestoppt sein zum Bearbeiten (aktuell: {{state}})",
  "vm_name_invalid": "Ungültiger VM-Name: {{name}}",
  "vm_name_taken": "VM-Name bereits vergeben: {{name}}",
  "vm_iso_not_found": "ISO nicht gefunden: {{filename}}",
  "vm_disk_shrink_not_supported": "Disk-Verkleinerung nicht unterstützt (aktuell {{current}} GB, gewünscht {{requested}} GB)",
  "qcow2_resize_failed": "Disk-Resize fehlgeschlagen: {{stderr}}",
  "qcow2_missing": "qcow2-Disk fehlt: {{path}}",
  "qemu_img_missing": "qemu-img nicht installiert",
  "container_must_be_stopped": "Container muss gestoppt sein zum Bearbeiten (aktuell: {{state}})",
  "container_name_invalid": "Ungültiger Container-Name: {{name}}",
  "container_name_taken": "Container-Name bereits vergeben: {{name}}",
  "git_failed": "Git-Operation fehlgeschlagen: {{detail}}",
  "git_no_repo": "Kein Git-Repository in diesem Workspace — bitte erst clonen oder leer initialisieren.",
  "git_no_remote": "Kein Remote konfiguriert.",
  "git_no_changes": "Keine Änderungen zu committen.",
  "git_workspace_not_empty": "Workspace ist nicht leer — clonen geht nur in leere Workspaces.",
  "git_empty_message": "Commit-Nachricht darf nicht leer sein.",
  "git_timeout": "Git-Operation hat zu lange gebraucht (Timeout).",

  "channel_unavailable": "Channel '{{channel}}' nicht verfügbar",

  "vm_not_found": "VM nicht gefunden",
  "vm_no_access": "Keine Berechtigung für diese VM",
  "vm_name_invalid": "VM-Name ungültig (1–32 Zeichen, beginnt mit Buchstabe, nur a-z A-Z 0-9 -)",
  "vm_name_taken": "Eine VM mit diesem Namen existiert bereits",
  "vm_network_mode_invalid": "Unbekannter Netzwerk-Modus",
  "vm_disk_interface_invalid": "Ungültiges Disk-Interface '{{value}}' — erlaubt: virtio, sata, ide",
  "vm_machine_type_invalid": "Ungültiger Machine-Type '{{value}}' — erlaubt: q35, pc",
  "vm_network_device_invalid": "Ungültiges Network-Device '{{value}}' — erlaubt: virtio-net-pci, e1000",
  "iso_not_found": "ISO '{{filename}}' nicht gefunden",
  "iso_invalid_name": "Ungültiger ISO-Dateiname",
  "iso_invalid_format": "Datei ist keine gültige ISO-9660 (Magic '{{magic}}')",
  "iso_too_large": "ISO zu groß ({{size}} Bytes, Maximum {{max}})",
  "iso_already_exists": "ISO '{{filename}}' existiert bereits",
  "iso_read_failed": "ISO konnte nicht gelesen werden: {{error}}",
  "qemu_img_missing": "qemu-img nicht installiert — bitte qemu-utils Paket installieren",
  "qemu_system_missing": "qemu-system-x86_64 nicht installiert",
  "qemu_start_failed": "QEMU-Start fehlgeschlagen (rc={{rc}})",
  "qemu_daemonize_timeout": "QEMU-Daemon-Start Timeout",
  "qemu_died_after_start": "QEMU-Prozess nach Start nicht mehr aktiv",
  "qemu_process_died": "QEMU-Prozess unerwartet beendet (vom Reconciler erkannt)",
  "qcow2_create_failed": "qcow2-Erzeugung fehlgeschlagen (rc={{rc}})",
  "qcow2_exists": "qcow2-Datei existiert bereits: {{path}}",
  "qcow2_missing": "qcow2-Datei fehlt: {{path}}",
  "vnc_ports_exhausted": "Alle VNC-Ports (5900–5999) belegt",
  "vm_not_running": "VM läuft nicht — Konsole erst nach Start verfügbar",
  "snapshot_not_found": "Snapshot nicht gefunden",
  "snapshot_name_invalid": "Snapshot-Name ungültig (1-64 Zeichen, nur a-z A-Z 0-9 _ . -)",
  "snapshot_vm_not_stopped": "VM muss gestoppt sein für Snapshot-Operationen",
  "snapshot_create_failed": "Snapshot erstellen fehlgeschlagen (rc={{rc}})",
  "snapshot_restore_failed": "Snapshot wiederherstellen fehlgeschlagen (rc={{rc}})",
  "snapshot_delete_failed": "Snapshot löschen fehlgeschlagen (rc={{rc}})",
  "import_source_missing": "Quell-Datei fehlt oder nicht lesbar",
  "import_format_unknown": "Disk-Format konnte nicht erkannt werden",
  "import_format_unsupported": "Format '{{format}}' wird nicht unterstützt (qcow2/raw/vmdk/vdi/vhd/vhdx)",
  "import_convert_failed": "qemu-img convert fehlgeschlagen (rc={{rc}})",
  "import_upload_failed": "Upload fehlgeschlagen: {{error}}",
  "import_internal_error": "Interner Import-Fehler",
  "import_job_not_found": "Import-Job nicht gefunden",
  "import_job_not_done": "Import-Job ist noch nicht fertig (Status: {{status_}})",
  "import_qcow2_missing": "qcow2 zum Import-Job fehlt — vermutlich gelöscht",
  "import_move_failed": "Import-qcow2 verschieben fehlgeschlagen: {{error}}",
  "container_not_found": "Container nicht gefunden",
  "container_no_access": "Keine Berechtigung für diesen Container",
  "container_name_invalid": "Container-Name ungültig (1-63 Zeichen, beginnt mit Buchstabe, nur a-z A-Z 0-9 -)",
  "container_name_taken": "Ein Container mit diesem Namen existiert bereits",
  "container_network_mode_invalid": "Unbekannter Netzwerk-Modus",
  "container_not_running": "Container läuft nicht (vom Reconciler erkannt)",
  "incus_missing": "incus nicht installiert — Installer Phase 10 ausstehend",
  "incus_timeout": "incus-Befehl Timeout",
  "incus_launch_failed": "incus launch fehlgeschlagen: {{stderr}}",
  "incus_start_failed": "incus start fehlgeschlagen: {{stderr}}",
  "incus_stop_failed": "incus stop fehlgeschlagen: {{stderr}}",
  "incus_restart_failed": "incus restart fehlgeschlagen: {{stderr}}",
  "incus_delete_failed": "incus delete fehlgeschlagen: {{stderr}}",

  "upload_file_too_large": "Die Datei „{{filename}}“ ist größer als {{max_mib}} MiB.",
  "upload_total_too_large": "Die Anhänge sind zusammen größer als {{max_mib}} MiB.",
  "upload_too_many_files": "Pro Nachricht sind höchstens {{max_files}} Anhänge erlaubt.",
  "upload_size_unknown": "Die Größe eines Anhangs konnte nicht sicher bestimmt werden.",
  "upload_request_too_large": "Die Upload-Anfrage ist inklusive Übertragungsdaten größer als {{max_mib}} MiB.",

  "ollama_not_configured": "Ollama ist noch nicht konfiguriert.",
  "ollama_unreachable": "Ollama ist nicht erreichbar.",
  "ollama_library_unavailable": "Die offizielle Ollama Library ist nicht erreichbar.",
  "invalid_ollama_family": "Ungültige Ollama-Modellfamilie.",
  "invalid_ollama_model": "Ungültiger Ollama-Modellname.",
  "ollama_pull_not_found": "Ollama-Download nicht gefunden.",
  "ollama_model_not_found": "Das Ollama-Modell ist nicht installiert.",
  "ollama_model_in_use": "Das Modell wird noch verwendet: {{references}}",

  "local_media_blocked": "Installation gesperrt ({{reason}}).",
  "local_media_busy": "Es läuft bereits eine Aktion für die lokale Bild-/Videogenerierung.",
  "local_media_not_installed": "Die lokale Bild-/Videogenerierung ist nicht installiert.",

  "group_exists": "Eine Gruppe mit diesem Namen gibt es schon",
  "group_not_found": "Gruppe nicht gefunden",
  "capability_unknown": "Unbekannte Funktion: {{capability}}",
  "subject_invalid": "Ungültiger Empfänger der Freigabe",
  "capability_denied": "Keine Freigabe für diese Funktion ({{capability}})",

  "validation_error": "{{message}}",
  "session_required": "Dafür ist eine Anmeldung nötig, ein API-Key reicht nicht",

  "peer_not_found": "Partner-Server nicht gefunden",
  "peer_code_invalid": "Kopplungscode ungültig",
  "peer_is_self": "Das ist der eigene Kopplungscode",
  "peer_exists": "Dieser Partner-Server ist schon gekoppelt",
  "peer_fingerprint_mismatch": "Fingerprint stimmt nicht überein",
  "peer_agent_unknown": "Agent {{agent_id}} gibt es hier nicht"
}
